import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_LOCATION}`,
  withCredentials: true,
  validateStatus: (status) => {
    // this is required in order to display error box
    // we return all responses with status between 200 and 500.
    // This allows us to handle these errors using a modal.
    // But we don't handle 401 since we want to handle those separately
    // on the login form.
    return status !== 401 && status >= 200 && status <= 500;
  },
});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/services/axios.js